module.exports = __webpack_public_path__ + "img/mine_login.32668f05.svg";